import * as variables from './variables.js';

import 'window.requestanimationframe';

import { Analytics } from '@plaudit/analytics';
Analytics.getInstance();

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

// NOTE: Colorbox must see jQuery on the window in order to work properly
import * as $ from 'jquery';
declare global {
	interface Window { jQuery: JQueryStatic; }
}
window.jQuery = $;


import Forms from './component/Forms';
Forms.init();

import MainMenu from './component/MainMenu';
new MainMenu({
	menu 			: '#menu',
	menuTarget 		: '.menu__inner',
	nodeTrigger 	: '.node--hasChild > a',
	triggers 		: '#menuTrigger--open, #menuTrigger--close, #menuOverlay',
	triggerEvent 	: 'click',
	collapsable: {
		duration: 400
	},
	styleClass: {
		setup 		: 'hasMenuSetup',
		menuOpen 	: 'hasMenuOpen',
		nodeOpen 	: 'isOpen'
	}
});

import './component/ChannelAddons';

import ChannelLineup from './component/ChannelLineup';
new ChannelLineup();

import CollapsableGroup from './component/CollapsableGroup';
new CollapsableGroup();

import Gallery from './component/Gallery';
new Gallery();

import InteractiveGraphic from './component/InteractiveGraphic';
new InteractiveGraphic();

import InternetPlans from './component/InternetPlans';
new InternetPlans();

import NewsletterSignup from './component/NewsletterSignup';
NewsletterSignup();

import offerInquiry from './component/offerInquiry';
offerInquiry();

import premierhqCarousel from './component/premierhqCarousel';
premierhqCarousel();

import * as stickybits from 'stickybits';
const stickybit = (stickybits as any)('.channelLineup thead', {
	useStickyClasses: true
});

import VideoLightbox from './component/VideoLightbox';
VideoLightbox();

import zipCodeSelector from './component/zipCodeSelector';
zipCodeSelector();

/* TODO: update this at some point to be a better build TS class */
import InputMask from './component/InputMask';

const accountNumberComponent = document.getElementById('addAuthorizedUsers\:accountNumber');
if (!!accountNumberComponent) {
	accountNumberComponent.addEventListener('input', function () {
		InputMask(this as HTMLInputElement, '00000000-0');
	});
}
